import React, { ReactNode } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { theme } from "../../constants/colors";

interface DialogProps {
  open: boolean;
  handleClose: () => void;
  title?: string;
  children: ReactNode;
}

const AppBottomDialog: React.FC<DialogProps> = ({
  open,
  handleClose,
  title,
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "100%",
          position: "absolute",
          left: 0,
          bottom: 0,
          top: "auto",
          margin: 0,
          borderRadius: "10px 10px 0 0",
          background: theme.colors.darkBg,
          zIndex: 999,
        },
      }}
    >
      <DialogTitle>
        <Typography
          color="white"
          variant="button"
          sx={{ textTransform: "none" }}
        >
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            right: 4,
            top: 4,
            color: "white",
          }}
          onClick={handleClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default AppBottomDialog;
